/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrackItDataSequenceAxisDto } from './TrackItDataSequenceAxisDto';
import {
    instanceOfTrackItDataSequenceAxisDto,
    TrackItDataSequenceAxisDtoFromJSON,
    TrackItDataSequenceAxisDtoFromJSONTyped,
    TrackItDataSequenceAxisDtoToJSON,
} from './TrackItDataSequenceAxisDto';

/**
 * @type TrackItDataSequenceInfoDtoPositions
 * 
 * @export
 */
export type TrackItDataSequenceInfoDtoPositions = TrackItDataSequenceAxisDto;


export function TrackItDataSequenceInfoDtoPositionsFromJSON(json: any): TrackItDataSequenceInfoDtoPositions {
    return TrackItDataSequenceInfoDtoPositionsFromJSONTyped(json, false);
}

export function TrackItDataSequenceInfoDtoPositionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItDataSequenceInfoDtoPositions {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...TrackItDataSequenceAxisDtoFromJSONTyped(json, true) };
    return  TrackItDataSequenceAxisDtoFromJSONTyped(json, true);
}

export function TrackItDataSequenceInfoDtoPositionsToJSON(value?: TrackItDataSequenceInfoDtoPositions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTrackItDataSequenceAxisDto(value)) {
        return TrackItDataSequenceAxisDtoToJSON(value as TrackItDataSequenceAxisDto);
    }

    return {};
}

/**
 * Check if a given object implements the TrackItDataSequenceInfoDtoPositions interface.
 */
export function instanceOfTrackItDataSequenceInfoDtoPositions(value: any): value is TrackItDataSequenceInfoDtoPositions {
    if (instanceOfTrackItDataSequenceAxisDto(value)) return true;
    return false;
}

